import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MaterialFolderGrid from "../components/MaterialFolderGrid";
import { getMaterialFolders, getMaterialInstitutionFolders } from "../helper/apicalls/materials";
import { getAllSubjects } from "../helper/apicalls/subject";
import "../styles/MaterialFolder.scss";

const Materials = () => {
  const navigate = useNavigate();
  const { coursekey } = useParams();
  const location = useLocation();
  
  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "course";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [courseFolders, setCourseFolders] = useState([]);
  const [institutionFolders, setInstitutionFolders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRootFolders = async () => {
      try {
        setLoading(true);

        let subjectsRes = [];
        let materialsRes = [];
        let instMaterialsRes = [];

        try {
          subjectsRes = await getAllSubjects(coursekey);
        } catch (e) {
          console.error("Failed to fetch subjects:", e);
        }

        try {
          materialsRes = await getMaterialFolders({ title: "course", key: coursekey || "" });
        } catch (e) {
          console.error("Failed to fetch course materials:", e);
        }

        try {
          instMaterialsRes = await getMaterialInstitutionFolders({ title: "course", key: coursekey || "" });
        } catch (e) {
          console.error("Failed to fetch institution materials:", e);
        }

        const subjects = Array.isArray(subjectsRes) ? subjectsRes : [];
        const materials = Array.isArray(materialsRes?.data)
          ? materialsRes.data
          : Array.isArray(materialsRes)
          ? materialsRes
          : [];
        const instMaterials = Array.isArray(instMaterialsRes?.data)
          ? instMaterialsRes.data
          : Array.isArray(instMaterialsRes)
          ? instMaterialsRes
          : [];

        const subjectFolders = subjects.map((s) => ({
          ...s,
          _kind: "subject",
        }));
        const courseMaterialFolders = materials.map((m) => ({
          ...m,
          _kind: "material",
        }));
        const institutionMaterialFolders = instMaterials.map((m) => ({
          ...m,
          _kind: "institution_material",
        }));

        setCourseFolders([...subjectFolders, ...courseMaterialFolders]);
        setInstitutionFolders([...subjectFolders, ...institutionMaterialFolders]);
      } catch (e) {
        console.error("Failed to load material folders", e);
        setCourseFolders([]);
        setInstitutionFolders([]);
      } finally {
        setLoading(false);
      }
    };

    if (coursekey) {
      fetchRootFolders();
    }
  }, [coursekey]);

  const handleOpenFolder = (folder) => {
    if (!folder) return;
    if (folder._kind === "subject" && folder.key) {
      navigate(`/materials/${coursekey}/${folder.key}?tab=${activeTab}`);
      return;
    }
    if (folder._kind === "material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}`);
      return;
    }
    if (folder._kind === "institution_material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}?type=institution`);
      return;
    }
  };

  const currentFolders = activeTab === "institution" ? institutionFolders : courseFolders;

  return (
    <div className="materials-page">
      <div className="materials-header">
        <h1 className="materials-title">Materials</h1>
      </div>

      <div className="materials-tabs">
        <button
          type="button"
          className={`materials-tab ${activeTab === "course" ? "active" : ""}`}
          onClick={() => setActiveTab("course")}
        >
          Course Resources
        </button>
        <button
          type="button"
          className={`materials-tab ${activeTab === "institution" ? "active" : ""}`}
          onClick={() => setActiveTab("institution")}
        >
          Institution Resources
        </button>
      </div>

      {loading ? (
        <div className="materials-loading">Loading materials...</div>
      ) : (
        <MaterialFolderGrid folders={currentFolders} onOpen={handleOpenFolder} />
      )}
    </div>
  );
};

export default Materials;
